export default "__VITE_ASSET__B5qgz537__"